/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Saved_VariantsInputs */

const en_jobs_saved_variants = /** @type {(inputs: Jobs_Saved_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved Variants`)
};

const de_jobs_saved_variants = /** @type {(inputs: Jobs_Saved_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespeicherte Varianten`)
};

const fr_jobs_saved_variants = /** @type {(inputs: Jobs_Saved_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variantes enregistrées`)
};

const es_jobs_saved_variants = /** @type {(inputs: Jobs_Saved_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variantes guardadas`)
};

const it_jobs_saved_variants = /** @type {(inputs: Jobs_Saved_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varianti salvate`)
};

const nl_jobs_saved_variants = /** @type {(inputs: Jobs_Saved_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgeslagen varianten`)
};

const pl_jobs_saved_variants = /** @type {(inputs: Jobs_Saved_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisane warianty`)
};

const fi_jobs_saved_variants = /** @type {(inputs: Jobs_Saved_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tallennetut versiot`)
};

const da_jobs_saved_variants = /** @type {(inputs: Jobs_Saved_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemte varianter`)
};

const sv_jobs_saved_variants = /** @type {(inputs: Jobs_Saved_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sparade varianter`)
};

/**
* | output |
* | --- |
* | "Saved Variants" |
*
* @param {Jobs_Saved_VariantsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_saved_variants = /** @type {((inputs?: Jobs_Saved_VariantsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Saved_VariantsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_saved_variants(inputs)
	if (locale === "fr") return fr_jobs_saved_variants(inputs)
	if (locale === "es") return es_jobs_saved_variants(inputs)
	if (locale === "it") return it_jobs_saved_variants(inputs)
	if (locale === "nl") return nl_jobs_saved_variants(inputs)
	if (locale === "pl") return pl_jobs_saved_variants(inputs)
	if (locale === "fi") return fi_jobs_saved_variants(inputs)
	if (locale === "da") return da_jobs_saved_variants(inputs)
	if (locale === "sv") return sv_jobs_saved_variants(inputs)
	return en_jobs_saved_variants(inputs)
});